import { getMetaTagsFromApi } from '../components/AssetDetails/api/assetsLookupsMetatags';
import { filterMetaTagsByCategory } from '../utils/assetDetails/filterMetaTagsByCategory';

const ADD_META_TAGS = 'ADD_META_TAGS';
const MARK_META_TAGS_LOADED = 'MARK_META_TAGS_LOADED';

const INITIAL_STATE = {
  isLoaded: false,
  metaTags: [],
  metaTagNameList: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_META_TAGS:
      return {
        ...state,
        metaTags: action.payload.metaTagsByCategory,
        metaTagNameList: action.payload.metaTagNameList,
      };
    case MARK_META_TAGS_LOADED:
      return {
        ...state,
        isLoaded: true,
      };
    default:
      return state;
  }
}

export function getMetaTags() {
  return async (dispatch) => {
    try {
      const metaTags = await getMetaTagsFromApi() || [];
      const metaTagsByCategory = filterMetaTagsByCategory(metaTags);
      const metaTagNameList = metaTags.map((tag) => tag.tagName);

      dispatch({
        type: ADD_META_TAGS,
        payload: { metaTagsByCategory, metaTagNameList },
      });

      dispatch({ type: MARK_META_TAGS_LOADED });

      return Promise.resolve({ metaTags });
    } catch (error) {
      return Promise.reject(error);
    }
  };
}
